module.exports = __webpack_public_path__ + "static/media/champion@2x.8f4618f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_42/imgs/champion@2x.png
// module id = 1003
// module chunks = 0